import Highlights from './Broucher/Highlights';
import PerformanceSpecifications from './Broucher/PerformanceSpecifications';
import ApplicationsAccessories from './Broucher/ApplicationsAccessories';
import FirstPage from './Broucher/FirstPage';
import { splitArrayIntoChunks } from '../../../generalFunctions';

const QuotationBroucher = ({ catalogDetails, image }) => {
    const arrayOfHighlightsTenElements = splitArrayIntoChunks(catalogDetails?.product_highlite || [], 10);
    const arrayOfPerfomanceSpecsElements = splitArrayIntoChunks(catalogDetails?.product_specification || [], 28);
    const arrayOfApplicationElements = splitArrayIntoChunks(catalogDetails?.product_application || [], 4);
    const arrayOfAccessoriesElements = splitArrayIntoChunks(catalogDetails?.product_accessory || [], 4);
    const oneWithMoreData = arrayOfApplicationElements.length > arrayOfAccessoriesElements.length ? arrayOfApplicationElements : arrayOfAccessoriesElements;

    return (
        <>
            {catalogDetails &&
                <div className="pdf-container">
                    <div className="page-content">
                        <FirstPage catalogDetails={catalogDetails} image={image} />
                    </div>

                    {arrayOfHighlightsTenElements.map((highliteChunk, chunkIndex) => {
                        return <div className="page-content" key={chunkIndex}>
                            <Highlights catalogDetails={highliteChunk} />
                        </div>
                    })}

                    {arrayOfPerfomanceSpecsElements.map((specificationChunk, chunkIndex) => {
                        return <div className="page-content" key={chunkIndex}>
                            <PerformanceSpecifications product_specification={specificationChunk} />
                        </div>
                    })}

                    {oneWithMoreData.map((applicationAccessoriesChunk, chunkIndex) => {
                        return <div className="page-content" key={chunkIndex}>
                            <ApplicationsAccessories product_application={arrayOfApplicationElements[chunkIndex]} product_accessory={arrayOfAccessoriesElements[chunkIndex]} />
                        </div>
                    })}
                </div>
            }
        </>
    );
};

export default QuotationBroucher;